import React from 'react';
import { Box, withStyles, Radio } from '@material-ui/core';
import { Link } from 'react-router-dom';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import { LazyLoadingComponent } from '@/../LazyLoading';
import config from '@/configs/config';

const Card = withStyles((theme) => ({
  root: {
    flexBasis: '50%',
    width: '50%',
    position: 'relative',
    padding: theme.spacing(1),
    minHeight: 130,
    [theme.breakpoints.up('sm')]: {
      flexBasis: '20%',
      width: '20%',
    },
  },
}))(Box);

export const FavBox = withStyles(() => ({
  root: {
    borderRadius: 8,
    position: 'absolute',
    right: 18,
    top: 18,
    zIndex: 50,
  },
}))(Box);

const StyleRadio = withStyles({
  root: {
    backgroundColor: '#f5f5f5',
    borderRadius: 8,
    boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.5)',
    padding: 2,
    transition: 'none',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    '&$checked': {
      color: 'black',
    },
  },
  checked: {
    backgroundColor: '#ffc822',
    '&:hover': {
      backgroundColor: '#ffc822 !important',
    },
  },

})(Radio);

export const FavButton = ({ checked }) => (
  <StyleRadio
    checked={checked}
    checkedIcon={<FavoriteIcon />}
    icon={<FavoriteBorderIcon />}
  />
);

export default ({
  data,
  onFavoritButtonClick,
}) => (
  <Box display="flex" flexWrap="wrap">
    {
      (data || []).map(({
        coverImage, encodedProviderName, isLiked, name,
      }) => (
        <Card key={name}>
          <FavBox onClick={async () => { await onFavoritButtonClick(encodedProviderName); }}>
            <FavButton checked={isLiked} />
          </FavBox>
          <Link to={`/providers/${name}`}>
            <LazyLoadingComponent>
              <Box width={1} pt="100%" position="relative">
                <img
                  src={`${config.RESOURCE_URI}${coverImage}`}
                  width="100%"
                  height="100%"
                  alt=""
                  key={coverImage}
                  style={{
                    left: 0,
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                  }}
                  onError={(e) => {
                    e.currentTarget.src = `${config.RESOURCE_URI}logo.png`;
                  }}
                />
              </Box>
            </LazyLoadingComponent>
            <div className="provider-name">{name}</div>
          </Link>
        </Card>
      ))
    }
  </Box>
);
